import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { EcallDetailService } from './ecall-detail.service';
import { EcallCancelService } from './ecall-cancel.service';
import { EcallStatus } from '../../../../model/enum';

import { DialogHelper, ExceptionHelper } from './../../../../helper';
import { Ecall } from '../../../../model';
import * as $ from 'jquery';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-ecall-detail',
  templateUrl: './ecall-detail.component.html',
  styleUrls: ['./ecall-detail.component.css']
})
export class EcallDetailComponent implements OnInit {

  @ViewChild('warningModal') warningModal: any;
  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  id = '';
  model: any;
  // statusName;
  ecallStatus = EcallStatus;
  isDownloading = false;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private ecallDetailService: EcallDetailService,
    private ecallCancelService: EcallCancelService,
    private route: ActivatedRoute,
    private router: Router,
    private chRef: ChangeDetectorRef,
    private translate: TranslateService
  ) {
    this.translate.setDefaultLang('en-us');
    this.route.params.subscribe(params => {
      this.id = params['id'];
    });
  }

  ngOnInit() {
    this.model = new Ecall();
    this.getDetail();
  }

  downloadServiceReport() {
    this.isDownloading = true;

    this.ecallDetailService.downloadServiceReport(this.model.serviceReportId).subscribe(data => {
      const blob = new Blob([data.file], { type: 'application/pdf' });
      saveAs(blob, data.fileName);
      this.isDownloading = false;
    }, error => {
      this.isDownloading = false;
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });
  }

  getDetail() {
    this.ecallDetailService
      .getDetail(this.id)
      .subscribe(
        data => {
          if (data) {
            this.model = data;
            // this.statusNumToStatusName(this.model.status);
          }
        },
        err => {
          $('.card').hide();
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = true;
        }
      );
  }


  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/e-call']);
    }
    else {
      this.dangerModal.hide();
    }
  }

  cancelPopUp() {
    this.dialog.showModal('showWarnModalBtn');
  }

  cancel() {
    this.warningModal.hide();

    this.ecallCancelService.cancel(this.id).subscribe(data => {

      this.dialog.showModal('showSucModalBtn');
      this.model = null;
      // this.chRef.detectChanges();
      // this.router.navigate([this.router.url]);
      this.ngOnInit();
    },
    error => {
      this.exception.showError(error, 'showDanModalBtn');
      this.redirect = false;
    });

  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-detail/ecall-detail.component.ts